var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(currency){return _c('ListItem',{key:currency.code,attrs:{"title":currency.name}},[_c('AeRadio',{attrs:{"slot":"right","checked":currency === _vm.active},on:{"change":function($event){return _vm.setCurrency(currency)}},slot:"right"})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }